module.exports = __webpack_public_path__ + "static/media/Logo.9c7ffd9a.png";